@import './media.css';

.skeletonLine1 {
  width: 14rem;

  @media (min-width: v-sm) {
    width: 24rem;
  }
}

.skeletonLine2 {
  width: 9rem;

  @media (min-width: v-sm) {
    width: 16rem;
  }
}

.skeletonLine3 {
  width: 12rem;

  @media (min-width: v-sm) {
    width: 20rem;
  }
}

.skeletonLine4 {
  width: 7rem;

  @media (min-width: v-sm) {
    width: 14rem;
  }
}

.link {
  color: hsl(var(--muted-foreground));
  text-decoration: underline;
}
